import React from 'react';
import Layout from '../components/layout/Layout';
import PaymentForm from '../components/payment/PaymentForm';

const PaymentPage: React.FC = () => {
  // Mock booking summary data (in a real app, this would come from state or API)
  const bookingSummary = {
    roomType: 'Deluxe Room',
    checkIn: '2025-07-15',
    checkOut: '2025-07-18',
    guests: 2,
    totalAmount: 450.00
  };

  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Complete Your Payment</h1>
        <div className="bg-white rounded-lg shadow-lg p-6">
          <PaymentForm bookingSummary={bookingSummary} />
        </div>
      </div>
    </Layout>
  );
};

export default PaymentPage;
